export default {
  weAreSis: {
    title: ['Somos', 'SIS'],
    description:
      'A SIS Innov & Tech é uma empresa provedora de serviços e soluções integradas de sistemas e consultoria de negócios, alinhada com as principais estratégias corporativas, por meio de uma equipe altamente qualificada. Nossa experiência e comprometimento refletem o alto nível de satisfação e reconhecimento dos nossos clientes.',
    button: 'SAIBA MAIS',
  },
}
